import { useEffect, useRef } from "react";
import { toast } from "sonner";

const fakeOrders = [
  { name: "Marie L.", city: "Paris", plan: "Clé en main", time: "il y a 2h" },
  { name: "Thomas B.", city: "Lyon", plan: "Sur-mesure", time: "il y a 4h" },
  { name: "Sophie M.", city: "Bordeaux", plan: "Clé en main", time: "il y a 6h" },
  { name: "Lucas D.", city: "Marseille", plan: "Starter", time: "il y a 8h" },
  { name: "Emma R.", city: "Toulouse", plan: "Clé en main", time: "il y a 12h" },
  { name: "Karim A.", city: "Nantes", plan: "Sur-mesure", time: "il y a 1j" },
  { name: "Julie P.", city: "Nice", plan: "Clé en main", time: "il y a 1j" },
  { name: "Antoine V.", city: "Lille", plan: "Starter", time: "il y a 2j" },
];

const SellFomoToasts = () => {
  const indexRef = useRef(0);
  const hasStarted = useRef(false);

  useEffect(() => {
    if (hasStarted.current) return;
    hasStarted.current = true;

    // First toast after 15 seconds
    const initialTimeout = setTimeout(() => {
      showToast();
      // Then every 35-55 seconds
      const interval = setInterval(() => {
        showToast();
      }, 35000 + Math.random() * 20000);
      return () => clearInterval(interval);
    }, 15000);

    return () => clearTimeout(initialTimeout);
  }, []);

  const showToast = () => {
    const order = fakeOrders[indexRef.current % fakeOrders.length];
    indexRef.current++;

    const isMobile = window.innerWidth < 768;
    toast(
      `🎉 ${order.name} (${order.city}) a commandé la formule ${order.plan}`,
      {
        description: order.time,
        duration: 5000,
        position: isMobile ? "top-center" : "bottom-left",
        className: "!bg-card !border-primary/20 !text-foreground !shadow-xl !text-xs sm:!text-sm",
      }
    );
  };

  return null;
};

export default SellFomoToasts;
